// Shared helpers for EditProjectDialog sub-components.
// Extracted from EditProjectDialog.jsx to keep the main dialog lean.
import { formatIDR } from "@/lib/constants";

/** Convert stored ISO datetime / date to yyyy-MM-dd for <input type="date"> */
export const toDateInput = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  } catch { return ""; }
};

export const toIso = (d) => (d ? new Date(d).toISOString() : null);

export const fieldLabels = {
  project_name: "Project Name",
  client: "Client",
  city: "City",
  province: "Province",
  start_date: "Start Date",
  end_date: "End Date",
  contract_value: "Contract Value",
  retention_pct: "Retention %",
  variation_order_name: "VO Name",
  vo_start_date: "VO Start Date",
  vo_end_date: "VO End Date",
  wo_number: "WO Number",
  wo_title: "Judul WO",
  work_description: "Work Description",
  wo_date: "WO Date",
  po_number: "PO Number",
  po_date: "PO Date",
  po_value: "PO Value",
  sph_submit_date: "SPH Submit Date",
  site_survey_date: "Site Survey Date",
  project_done_date: "Project Done Date",
  invoice_sent_date: "Invoice Sent Date",
  perlu_tindakan_manual: "Perlu Tindakan (manual)",
  parent_project_id: "Parent Project",
};

export const formatHistoryValue = (field, v) => {
  if (v == null || v === "") return "—";
  if (field === "contract_value" || field === "po_value") return formatIDR(v);
  if (field === "retention_pct") return `${v}%`;
  if (field.endsWith("_date")) {
    try { return new Date(v).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }); }
    catch { return String(v); }
  }
  return String(v);
};
